<template>
  <v-app v-cloak>

    <!-- Helper Button in order to catch events from application -->
    <button id="appListener" @click="eventFromApp" v-show="false"></button>
    <splash v-if="splash"></splash>
    <!-- is not splash -->
    <div v-else>
      <!-- Appbar -->
      <Appbar v-if="hasAppbar()"></Appbar>
      <v-main v-if="accessToPage" :class="rootClass()">
        <!-- Router View -->
        <router-view id="page-body"></router-view>
        <!-- Sidebar -->
        <Sidebar v-if="sidebar" :show="showSidebar"></Sidebar>
        <!-- Fixed Bottom Navigation for Dashboard Pages -->
      </v-main>
      <!-- global snackbar section -->
      <Snack></Snack>
      <!-- global Popup section for notif and confirm popups-->
      <Popup></Popup>
    </div>
  </v-app>
</template>
<style>
  @import './assets/css/style.css';
</style>
<script>
    import {mapState, mapActions, mapGetters} from "vuex";
    import Sidebar from "./general/Sidebar";
    import Snack from "./general/Snack";
    import Appbar from "./general/Appbar";
    import Popup from "./general/Popup";
    import Splash from "./general/splash";

    export default {
        name: 'App',
        components: {
            Splash,
            Popup,
            Appbar,
            Snack,
            Sidebar,
        },
        data: function () {
            return {
                sidebar: false,
            };
        },
        computed: {
            ...mapState(['token', 'hasNavigation', 'showSidebar']),
            ...mapState('init', ['splash', 'accessToPage']),
            ...mapGetters(['authenticated']),
        },
        watch: {
            async '$route'(to) {
                this.sidebar = this.hasSidebar();

                this.setSidebar(false);

                this.setNavigation(false);
                const access = this.hasAccessToPage(to.name);
                this.setAccessToPage(access);

                if (!access && to.name !== 'userLogin')
                    await this.$router.replace('/user/login');

            },
        },
        methods: {
            ...mapActions(['appCommand', 'setNavigation', 'eventFromApp', 'setSidebar']),
            ...mapActions('init', ['appInitialize', 'setAccessToPage', 'mobTestInitial']),
            isUserPages() {
                return window.location.href.indexOf("/user/") > -1
            },
            isHome() {
                return this.$route.name === 'home';
            },
            hasAppbar() {
                return !this.isUserPages();
            },
            hasSidebar() {
                !this.isUserPages();
            },
            hasAccessToPage(routeName) {
                return this.authenticated
                    || ['userLogin', 'userRegister'].includes(routeName);
            },
            rootClass() {
                let className = process.env.VUE_APP_MODE === 'mob' ? 'container-fluid' : 'container';
                if (process.env.VUE_APP_MODE === 'web' && !this.authenticated)
                    className += ' p-0';
                return className;

            }
        },
        async mounted() {

            this.sidebar = this.hasSidebar();

            this.appInitialize();
        }
    };
</script>